import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { StyledButton } from 'components/Buttons';
import { LoaderFullScreen } from 'components/Loaders/LoaderFullScreen';
import { useTranslation } from 'react-i18next';
import { appToast } from 'utils/toast.utils';
import { useDeleteStormRate } from 'api/rates';
import * as S from './ConfirmDeleteRateDialog.css';

type Props = {
  open: boolean;
  rate: { id: number; rateNumber: string } | null;
  onClose: () => void;
  onSubmit: () => Promise<void> | void;
};

export const ConfirmDeleteRateDialog = ({
  open,
  rate,
  onClose,
  onSubmit,
}: Props) => {
  const { t } = useTranslation(['misc', 'rates']);

  const { loading: deleteLoading, deleteStormRate } = useDeleteStormRate();

  const handleDelete = async () => {
    if (!rate) return;

    try {
      const rateId = String(rate.id);
      const response = await deleteStormRate(rateId);

      if (response?.status === 200) {
        appToast.success(t('deleteRateSuccess', { ns: 'rates' }));
        onClose();
        await onSubmit();
      } else {
        appToast.error(t('deleteRateFailure', { ns: 'rates' }));
      }
    } catch (error) {
      appToast.error(t('deleteRateFailure', { ns: 'rates' }));
      console.error('Error deleting rate:', error);
    }
  };

  return (
    <S.StyledDialog open={open} onClose={onClose}>
      <LoaderFullScreen loading={deleteLoading} />
      <DialogTitle>{t('deleteRateHeading', { ns: 'rates' })}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          {t('deleteRateBody', {
            ns: 'rates',
            rateNumber: rate?.rateNumber,
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StyledButton $primary onClick={handleDelete} disabled={!rate}>
          {t('button.delete', { ns: 'misc' })}
        </StyledButton>
        <StyledButton onClick={onClose}>
          {t('button.cancel', { ns: 'misc' })}
        </StyledButton>
      </DialogActions>
    </S.StyledDialog>
  );
};
